import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer-custom" style={{ backgroundColor: '#0f172a', color: '#94a3b8', borderTop: '1px solid #1e293b' }}>
      {/* SLA & Terms Footnote (Footer-Adjacent) */}
      <div style={{
        borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
        backgroundColor: '#0b1120',
        padding: '1.25rem 0',
        fontSize: '0.82rem',
        color: '#94a3b8'
      }}>
        <Container className="container-custom">
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
            <span style={{ color: '#38bdf8', fontSize: '1rem', marginTop: '0.1rem' }}>ℹ️</span>
            <div>
              <strong style={{ color: '#e2e8f0' }}>SLA &amp; Terms Footnote: </strong>
              All service level agreements (SLAs), uptime targets, maintenance response windows, project deliverables, and delivery timelines are custom-scoped and contractually defined exclusively within each signed Statement of Work (SOW) between Guru&apos;s Workshop LLC and the client.
            </div>
          </div>
        </Container>
      </div>

      <Container className="container-custom" style={{ padding: '3.5rem 15px 2rem 15px' }}>
        <Row className="gy-4">
          {/* Brand & Overview */}
          <Col lg={4} md={6} style={{ textAlign: 'left' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.65rem', marginBottom: '0.9rem' }}>
              <div style={{
                width: '30px',
                height: '30px',
                borderRadius: '8px',
                background: 'linear-gradient(135deg, #1d4ed8, #1e40af)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#ffffff',
                fontWeight: 900,
                fontSize: '0.95rem'
              }}>
                G
              </div>
              <h2 style={{ fontFamily: 'Outfit, sans-serif', fontWeight: 900, fontSize: '1.3rem', margin: 0, letterSpacing: '-0.02em', color: '#ffffff' }}>
                GURU&apos;S WORKSHOP<span style={{ color: '#38bdf8' }}>.</span>
              </h2>
            </div>
            <p style={{ color: '#94a3b8', fontSize: '0.9rem', lineHeight: '1.6', maxWidth: '330px', margin: 0 }}>
              Guru&apos;s Workshop LLC provides bespoke enterprise software engineering, scalable cloud architecture, and maintenance retainers.
            </p>
            <div style={{
              marginTop: '1rem',
              padding: '0.6rem 0.9rem',
              backgroundColor: 'rgba(255, 255, 255, 0.04)',
              border: '1px solid rgba(255, 255, 255, 0.08)',
              borderRadius: '8px',
              fontSize: '0.82rem',
              color: '#cbd5e1'
            }}>
              <strong>Pricing:</strong> Projects typically start at $___ — TODO: owner to fill
            </div>
            <div style={{ fontSize: '0.8rem', color: '#64748b', marginTop: '1.2rem' }}>
              &copy; 2026 Guru&apos;s Workshop LLC. All rights reserved.
            </div>
          </Col>

          {/* Software Services */}
          <Col lg={3} md={6} style={{ textAlign: 'left' }}>
            <h4 style={{ fontSize: '0.88rem', fontWeight: 700, marginBottom: '1rem', color: '#f1f5f9', letterSpacing: '0.04em', textTransform: 'uppercase' }}>
              Software Services
            </h4>
            <ul style={{ listStyle: 'none', padding: 0, fontSize: '0.9rem', lineHeight: '2.1' }}>
              <li>
                <Link to="/rfp" style={{ color: '#38bdf8', textDecoration: 'none', fontWeight: 600 }}>
                  📋 Request for Proposal (RFP)
                </Link>
              </li>
              <li>
                <Link to="/calculator" style={{ color: '#94a3b8', textDecoration: 'none' }}>
                  ⚙️ SLA Retainer Calculator
                </Link>
              </li>
              <li>
                <a href="/#services" style={{ color: '#94a3b8', textDecoration: 'none' }}>
                  Full-Stack Cloud Engineering
                </a>
              </li>
              <li>
                <a href="/#services" style={{ color: '#94a3b8', textDecoration: 'none' }}>
                  Legacy Modernization &amp; DevOps
                </a>
              </li>
              <li>
                <Link to="/project" style={{ color: '#94a3b8', textDecoration: 'none' }}>
                  Project SOW Tracker
                </Link>
              </li>
            </ul>
          </Col>

          {/* Shipped Systems & Studio Link */}
          <Col lg={2} md={6} style={{ textAlign: 'left' }}>
            <h4 style={{ fontSize: '0.88rem', fontWeight: 700, marginBottom: '1rem', color: '#f1f5f9', letterSpacing: '0.04em', textTransform: 'uppercase' }}>
              Ecosystem
            </h4>
            <ul style={{ listStyle: 'none', padding: 0, fontSize: '0.9rem', lineHeight: '2.1' }}>
              <li>
                <Link to="/tape" style={{ color: '#94a3b8', textDecoration: 'none' }}>
                  Tape Intelligence
                </Link>
              </li>
              <li>
                <a href="https://apps.apple.com/us/app/tape-record/id6766102917" target="_blank" rel="noopener noreferrer" style={{ color: '#94a3b8', textDecoration: 'none' }}>
                  App Store Releases
                </a>
              </li>
              <li>
                <Link to="/orders" style={{ color: '#94a3b8', textDecoration: 'none' }}>
                  Pipeline Portal
                </Link>
              </li>
            </ul>
          </Col>

          {/* Contact & Location */}
          <Col lg={3} md={6} style={{ textAlign: 'left' }}>
            <h4 style={{ fontSize: '0.88rem', fontWeight: 700, marginBottom: '1rem', color: '#f1f5f9', letterSpacing: '0.04em', textTransform: 'uppercase' }}>
              Contact &amp; Location
            </h4>
            <ul style={{ listStyle: 'none', padding: 0, fontSize: '0.9rem', lineHeight: '2.1' }}>
              <li>
                <a href="mailto:contact@gurusworkshop.com" style={{ color: '#94a3b8', textDecoration: 'none' }}>
                  ✉️ contact@gurusworkshop.com
                </a>
              </li>
              <li>
                {/* TODO: Owner to fill phone number when available */}
                <a href="tel:+1-TODO-OWNER-PHONE" style={{ color: '#94a3b8', textDecoration: 'none' }}>
                  📞 (TODO: owner to fill phone)
                </a>
              </li>
              <li style={{ color: '#94a3b8' }}>
                📍 Weston, FL
              </li>
              <li>
                <Link to="/tape-privacy" style={{ color: '#64748b', textDecoration: 'none', fontSize: '0.82rem' }}>
                  Privacy Policy
                </Link>
                <span style={{ color: '#475569', margin: '0 0.4rem' }}>&bull;</span>
                <Link to="/tape-terms" style={{ color: '#64748b', textDecoration: 'none', fontSize: '0.82rem' }}>
                  Terms
                </Link>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
